import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, FctValue16, FctValue40, FctValue128, FctValue128_27 } from '../../../../Fct/generics';
import { getAaveV3Tokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { POOL_ADDRESSES } from '../constants';
export var GetReserveData = createPlugin({
    protocol: 'AaveV3',
    type: 'GETTER',
    method: 'getReserveData',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveV3Tokens({ chainId: chainId }) }),
                },
            },
            output: {
                configuration: new FctValue({ innerIndex: 0 }),
                liquidityIndex: new FctValue128_27({ innerIndex: 1 }),
                currentLiquidityRate: new FctValue128_27({ innerIndex: 2 }),
                variableBorrowIndex: new FctValue128_27({ innerIndex: 3 }),
                currentVariableBorrowRate: new FctValue128_27({ innerIndex: 4 }),
                currentStableBorrowRate: new FctValue128_27({ innerIndex: 5 }),
                lastUpdateTimestamp: new FctValue40({ innerIndex: 6 }),
                id: new FctValue16({ innerIndex: 7 }),
                aTokenAddress: new FctAddress({ innerIndex: 8 }),
                stableDebtTokenAddress: new FctAddress({ innerIndex: 9 }),
                variableDebtTokenAddress: new FctAddress({ innerIndex: 10 }),
                interestRateStrategyAddress: new FctAddress({ innerIndex: 11 }),
                accruedToTreasury: new FctValue128({ innerIndex: 12 }),
                unbacked: new FctValue128({ innerIndex: 13 }),
                isolationModeTotalDebt: new FctValue128({ innerIndex: 14 }),
            },
        });
    },
});
